define([
	"dojo/_base/declare",
	"csi/view",
	"SiteAdmin/LocaleResourceController"
], function(declare,view,LocaleResourceController) {

	return declare(LocaleResourceController, {
		postProcessSuccess: function() {
			// summary: refresh attributes table
			this.inherited(arguments);
			view.getView("LocaleAttributes").refreshWidget();
		}
	});
});